export default __webpack_public_path__ + "static/media/playstore.5ef7a4a5.png";